import { IRequestOptions, IRequestConfig, getConfigs, axios } from './serviceOptions';
const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class AuthenticationService {
  /**
   * Login
   */
  static loginV10AuthTokenPost(options: IRequestOptions = {}): Promise<Token> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/auth/token';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Refresh Token
   */
  static refreshTokenV10AuthRefreshGet(options: IRequestOptions = {}): Promise<Token> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/auth/refresh';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class UsersService {
  /**
   * Whoami
   */
  static whoamiV10UsersMeGet(options: IRequestOptions = {}): Promise<User> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/users/me';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * List Users
   */
  static listUsersV10UsersGet(options: IRequestOptions = {}): Promise<User[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/users/';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Create User
   */
  static createUserV10UsersPost(
    params: {
      /** requestBody */
      body?: UserCreate;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<User> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/users/';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete User
   */
  static deleteUserV10UsersUserIdDelete(
    params: {
      /**  */
      userId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/users/{user_id}';
      url = url.replace('{user_id}', params['userId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class RestaurantsService {
  /**
   * Get Restaurants
   */
  static getRestaurantsV10RestaurantsGet(
    params: {
      /**  */
      offset?: number;
      /**  */
      limit?: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Restaurant[]> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/restaurants/';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { offset: params['offset'], limit: params['limit'] };
      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Create Restaurant
   */
  static createRestaurantV10RestaurantsPost(
    params: {
      /** requestBody */
      body?: RestaurantCreate;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Restaurant> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/restaurants/';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Restaurant
   */
  static getRestaurantV10RestaurantsRestaurantIdGet(
    params: {
      /**  */
      restaurantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Restaurant> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/restaurants/{restaurant_id}';
      url = url.replace('{restaurant_id}', params['restaurantId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete Restaurant
   */
  static deleteRestaurantV10RestaurantsRestaurantIdDelete(
    params: {
      /**  */
      restaurantId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/restaurants/{restaurant_id}';
      url = url.replace('{restaurant_id}', params['restaurantId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export class ReviewsService {
  /**
   * Create Review
   */
  static createReviewV10ReviewsPost(
    params: {
      /** requestBody */
      body?: ReviewCreate;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Review> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/reviews/';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Get Review
   */
  static getReviewV10ReviewsReviewIdGet(
    params: {
      /**  */
      reviewId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<Review> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/reviews/{review_id}';
      url = url.replace('{review_id}', params['reviewId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
  /**
   * Delete Review
   */
  static deleteReviewV10ReviewsReviewIdDelete(
    params: {
      /**  */
      reviewId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/v1_0/reviews/{review_id}';
      url = url.replace('{review_id}', params['reviewId'] + '');

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options);

      let data = null;

      configs.data = data;
      axios(configs, resolve, reject);
    });
  }
}

export interface Body_login_v1_0_auth_token_post {
  /**  */
  grant_type?: string;

  /**  */
  username?: string;

  /**  */
  password?: string;

  /**  */
  scope?: string;

  /**  */
  client_id?: string;

  /**  */
  client_secret?: string;
}

export interface HTTPValidationError {
  /**  */
  detail?: ValidationError[];
}

export interface Restaurant {
  /**  */
  name?: string;

  /**  */
  id?: string;

  /**  */
  owner_id?: string;

  /**  */
  created_date?: Date;

  /**  */
  reviews_average?: number;

  /**  */
  reviews_sum?: number;

  /**  */
  reviews_N?: number;

  /**  */
  reviews?: Review[];
}

export interface RestaurantCreate {
  /**  */
  name?: string;
}

export interface Review {
  /**  */
  comment?: string;

  /**  */
  stars?: number;

  /**  */
  restaurant_id?: string;

  /**  */
  id?: string;

  /**  */
  created_date?: Date;

  /**  */
  author_id?: string;

  /**  */
  responded?: boolean;

  /**  */
  response?: string;

  /**  */
  response_date?: Date;

  /**  */
  respondant_id?: string;
}

export interface ReviewCreate {
  /**  */
  comment?: string;

  /**  */
  stars?: number;

  /**  */
  restaurant_id?: string;
}

export interface Token {
  /**  */
  access_token?: string;

  /**  */
  token_type?: string;
}

export interface User {
  /**  */
  username?: string;

  /**  */
  id?: string;

  /**  */
  role?: RoleEnum;

  /**  */
  reviews?: Review[];

  /**  */
  restaurants?: Restaurant[];

  /**  */
  created_date?: Date;
}

export interface UserCreate {
  /**  */
  username?: string;

  /**  */
  password?: string;
}

export interface ValidationError {
  /**  */
  loc?: string[];

  /**  */
  msg?: string;

  /**  */
  type?: string;
}

export enum RoleEnum {
  'basic' = 'basic',
  'owner' = 'owner',
  'admin' = 'admin'
}
